import { Box } from "@mui/material";
import React, { useState } from "react";
import {
  createFilterModel,
  createOrderModel,
  createPaginationModel,
  eliminateOjectNotTruthyValues,
} from "../../lib/helperFuncs";
import FilterComponent from "./FilterComponent";
import TableGrid from "./TableGrid";
import axios from "axios";

const TableGridWithFilters = ({
  initialValues,
  filterFields,
  resetFilters,
  validationSchema,
  columns,
  pageSize = 10,
  page = 0,
  rows: _rows = [],
  rowsPerPageOptions = [10, 20, 50],
  paginationMode = "client",
  sortingMode = "client",
  sortModel: _sortModel = [],
  fetchUrl,
  onFetch, //returns response.data
  onFiltersChange, //returns filters' values
  componentInBetween,
  reFetch,
  hideFilters = false,
  isProblematic,
}) => {
  const [filters, setFilters] = useState(initialValues);
  const [rows, setRowsArray] = useState(_rows);
  const [totalCount, setTotalCount] = useState(0);
  const [isFetching, setIsFetching] = useState(true);

  const [sortModel, setSortModel] = useState(_sortModel);

  const [_pageSize, setPageSize] = useState(
    paginationMode === "server" ? pageSize : undefined,
  );
  const [_page, setPage] = useState(page);

  const handleSortModelChange = (newModel) => {
    setSortModel(newModel);
  };

  const buildFilterBody = (values) => {
    setFilters(createFilterModel(values));
    if (onFiltersChange) {
      onFiltersChange(values);
    }
  };

  const sortingProps = {
    ...(sortingMode === "server" && {
      sortModel: sortModel,
      onSortModelChange: handleSortModelChange,
    }),
  };

  const paginationProps = {
    ...(paginationMode === "server" && {
      fetchingFunction: (pageSize, page) => {
        setPageSize(pageSize);
        setPage(page);
      },
      setPageSize: setPageSize,
      page: _page,
      setPage: setPage,
    }),
  };

  const handleRows = async (page, pageSize, sortModel) => {
    try {
      setIsFetching(true);
      const response = await axios.get(fetchUrl, {
        params: eliminateOjectNotTruthyValues({
          ...filters,
          ...createPaginationModel(page, pageSize),
          ...createOrderModel(sortModel),
        }),
        withCredentials: true,
      });
      setRowsArray(response.data.records);
      setTotalCount(response.data.total_count);
      if (onFetch) {
        onFetch(response.data);
      }
      setIsFetching(false);
    } catch (e) {
      console.error(e);
    }
  };

  React.useEffect(() => {
    let active = true;
    (async () => {
      handleRows(_page, _pageSize, sortModel);

      if (!active) {
        return;
      }
    })();

    return () => {
      active = false;
    };
  }, [sortModel, filters, _page, _pageSize, reFetch]);

  return (
    <>
      <Box width="100">
        {!hideFilters && (
          <FilterComponent
            resetFilters={resetFilters}
            initialValues={initialValues}
            filterFields={filterFields}
            changeFilters={buildFilterBody}
            validationSchema={validationSchema}
          />
        )}
        {componentInBetween}
        <Box sx={{ width: "100%", my: 1 }}>
          <TableGrid
            {...paginationProps}
            {...sortingProps}
            paginationMode={paginationMode}
            rows={rows}
            isFetching={isFetching}
            columns={columns}
            totalCount={totalCount}
            pageSize={paginationMode === "server" ? _pageSize : pageSize}
            rowsPerPageOptions={rowsPerPageOptions}
            isProblematic={isProblematic}
          />
        </Box>
      </Box>
    </>
  );
};

export default TableGridWithFilters;
